import { TwitchLogo, DiscordLogo, YoutubeLogo, TiktokLogo, InstagramLogo, XLogo } from "@phosphor-icons/react";
import { SOCIALS, BUSINESS_EMAIL } from "../config/socials";

const socials = [
    { icon: TwitchLogo, href: SOCIALS.twitch.url, label: "Twitch", testId: "footer-twitch" },
    { icon: DiscordLogo, href: SOCIALS.discord.url, label: "Discord", testId: "footer-discord" },
    { icon: YoutubeLogo, href: SOCIALS.youtube.url, label: "YouTube", testId: "footer-youtube" },
    { icon: TiktokLogo, href: SOCIALS.tiktok.url, label: "TikTok", testId: "footer-tiktok" },
    { icon: InstagramLogo, href: SOCIALS.instagram.url, label: "Instagram", testId: "footer-instagram" },
    { icon: XLogo, href: SOCIALS.x.url, label: "X", testId: "footer-x" },
];

export const Footer = () => {
    return (
        <footer className="relative pt-20 pb-10 border-t border-white/[0.06]" data-testid="footer">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
                    <div>
                        <div className="font-display font-semibold text-3xl gradient-text mb-3">itz_ool</div>
                        <p className="text-white/50 text-sm max-w-xs leading-relaxed">
                            Daily variety streamer. Building a real community on Twitch, one stream at a time.
                        </p>
                    </div>
                    <div>
                        <div className="eyebrow mb-4">Channels</div>
                        <ul className="space-y-2 text-sm">
                            {Object.entries(SOCIALS).map(([k, s]) => (
                                <li key={k}>
                                    <a
                                        href={s.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-white/65 hover:text-white transition-colors font-mono"
                                        data-testid={`footer-link-${k}`}
                                    >
                                        {s.label} · <span className="text-white/40">{s.handle}</span>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <div className="eyebrow mb-4">Business</div>
                        <a
                            href={`mailto:${BUSINESS_EMAIL}`}
                            className="text-white hover:text-brand-cyan transition-colors font-mono text-sm break-all"
                            data-testid="footer-business-email"
                        >
                            {BUSINESS_EMAIL}
                        </a>
                        <p className="text-xs text-white/40 mt-3 leading-relaxed">
                            Collabs, sponsorships, press inquiries — use the email or the contact page.
                        </p>
                    </div>
                </div>

                <div className="divider mb-6" />

                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
                    <div className="text-xs text-white/40">
                        © {new Date().getFullYear()} itz_ool · All rights reserved.
                    </div>
                    <div className="flex items-center gap-2" data-testid="footer-socials">
                        {socials.map((s) => (
                            <a
                                key={s.label}
                                href={s.href}
                                target="_blank"
                                rel="noreferrer"
                                className="h-9 w-9 rounded-full bg-white/5 border border-white/10 hover:border-white/30 flex items-center justify-center text-white/60 hover:text-white transition"
                                data-testid={s.testId}
                                aria-label={s.label}
                            >
                                <s.icon size={14} weight="fill" />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
};
